import { WellDayDepthWidgetWrapper } from '../../well-day-depth-widget/DayDepthChartWidget';
import type { DayDepthChartWidgetEntity } from '../../well-day-depth-widget/DayDepthChartWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderDayDepthChartWidget(
  widget: DayDepthChartWidgetEntity,
  options: TWidgetRendererOptions,
): TRenderWidget {
  return () => <WellDayDepthWidgetWrapper entity={widget} options={options} />;
}
